import React from 'react'
import Navbar from '../../Components/Navbar/navbar'
import Footer from '../../Components/Footer/footer'

import AboutMed from '../../assets/images/about-medicine.png'
export default function about() {
  return (

    <>
      <Navbar />
      <section className="about_section ">
    <div className="container">
      <div className="custom_heading-container ">
        <h2>
          About Us
        </h2>
      </div>

      <div className="img-box">
        <img src={AboutMed} alt=""/>
      </div>
      <div className="detail-box">
        <p>
          It is a long established fact that a reader will be distracted by the readable content of a page when looking
          at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as
          opposed to using 'Content here, content here', making it
        </p>
        <div className="d-flex justify-content-center">
          <a href="#!">
            Read More
          </a>
        </div>
      </div>
    </div>
      </section>
      <Footer/>
    </>
  )
}
